<template>
    <main>
		<HeaderTab 
            :title="$t('notes.infos_note')"
            :icon="['fal', 'sticky-note']"
        />

        <div id="content">
            <shutter-panel />
        </div>
	</main>
</template>


<script type="text/javascript">
    import Shutter from '@/mixins/Shutter.js'
    import ShutterNotes from '@/mixins/shutters-manager/Notes.js'

	export default {
		name: "noteListe",
        mixins: [Shutter, ShutterNotes],
        computed: {
            noteId() {
                return this.$route.params.note_id
            }
        },
        mounted() {
            this.setupNotePreview(this.noteId)
        },
		components: {
            HeaderTab: () => import('@/components/HeaderTab'),
			NotePreview: () => import('@/components/Notes/NotePreview')
		}
	}
</script>
